import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const ProductInformationContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      accessible
      focusable
      {...props}
      style={[
        styles.productInformationContainer,
        isDesktop && styles.productInformationContainerDesktop,
        style,
      ]}
    />
  );
};

export const ProductInformationTitle = Text.withConfig({
  variant: 'headerThree',
  marginY: '$4',
});

export const ProductInformationDescription = Text.withConfig({ variant: 'copyTwo' });

const styles = StyleSheet.create({
  productInformationContainer: {
    marginTop: 16,
    paddingHorizontal: 16,
  },
  productInformationContainerDesktop: {
    marginTop: 32,
    paddingHorizontal: 0,
  },
});
